import { Container, Eyebrow, LandingButton } from "./primitives";
import { useOpenContact } from "./ContactModal";

export function OrganizationsSection() {
  const openContact = useOpenContact();
  return (
    <section id="organizations" className="scroll-mt-[68px] bg-[#F3F4F8] py-16 lg:py-20">
      <Container>
        <div className="relative overflow-hidden rounded-[24px] bg-[#120240] px-8 py-12 md:px-16 md:pt-[64px] md:pb-[56px]">
          {/* Decorative circle, top-right */}
          <span
            aria-hidden="true"
            className="pointer-events-none absolute -right-[71px] -top-[69px] h-[330px] w-[330px] rounded-full bg-[rgba(228,0,43,0.06)]"
          />

          <div className="relative flex flex-col gap-10 lg:flex-row lg:items-center lg:justify-between">
            <div className="max-w-[560px]">
              <Eyebrow>For healthcare organizations</Eyebrow>
              <h2 className="!mt-3.5 text-[30px] font-extrabold leading-[1.14] tracking-[-0.035em] text-white md:text-[36px]">
                Format-agnostic ingestion.
                <br />
                Enterprise-grade audit tooling.
              </h2>
              <p className="!mt-5 max-w-[470px] text-[15px] leading-[26px] text-white/60">
                HL7, FHIR, CCD, PDF, scans: whatever format your records come in, MedSyncIQ processes them.
                Complete access logs, configurable retention, and a compliance-ready audit trail.
              </p>
            </div>
            <LandingButton
              variant="outline-light"
              arrow
              onClick={() => openContact("demo")}
              className="!h-[52px] !w-[198px] !shrink-0 !text-[15px]"
            >
              Request a Demo
            </LandingButton>
          </div>
        </div>
      </Container>
    </section>
  );
}
